import React from 'react';
import './Footer.css';
import FooterNav from '../Common/FooterNav';
import FooterContact from '../Common/FooterContact';
import MenuSocials from '../Common/MenuSocials';
import Ig from '../../Assets/Icons/Ig.svg';
import Tw from '../../Assets/Icons/Tw.svg';
import Yt from '../../Assets/Icons/Yt.svg';
import Fb from '../../Assets/Icons/Fb.svg';

const Footer = () => {
    return ( 
        <footer>
            <div className='FooterTop'>
                <div className='FCol'>
                    <h3 className='Logo'>
                        AXIS
                    </h3>
                    <p className='FooterP'> 
                        Axis's fully-finished residential properties feature modern architecture and are complemented by spacious green areas. The community provides top-tier amenities that harmoniously blend sustainability with exceptional quality of life, setting it apart as a premium residential destination.
                    </p>
                    <div className="socials">
                        <MenuSocials menuSocial={Ig} menuSocialAlt='Instagram logo' />
                        <MenuSocials menuSocial={Tw} menuSocialAlt='Twitter logo' />
                        <MenuSocials menuSocial={Yt} menuSocialAlt='Youtube logo' />
                        <MenuSocials menuSocial={Fb} menuSocialAlt='Facebook logo' />
                    </div>
                </div>

                <div className='FCol'>
                    <FooterNav />
                </div>

                <div className='FCol'>
                    <FooterContact />
                </div>
            </div>
        </footer>
     );
}
 
export default Footer;